import { useEffect, useMemo } from 'react';
// store
import useThemeStore from 'Theme/store';
// styles
import { styled, Switch } from '@mui/material';

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 48,
  height: 24,
  padding: 0,
  borderWidth: 2,
  borderRadius: 24 / 2,
  margin: '0 !important',
  '& .MuiSwitch-switchBase': {
    padding: 1.5,
    transform: 'translateX(1px)',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      '& + .MuiSwitch-track': {
        backgroundColor: 'rgba(70, 75, 186, 0.4)',
      },
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#FFFFFF'
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 17,
    height: 17,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#39383A'
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
}));

const ToggleTheme = ({ classNameContainer }) => {
  const { theme, setTheme } = useThemeStore();

  const handleToggle = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    const htmlElement = document.querySelector('html');
    htmlElement.classList.remove('light', 'dark');
    htmlElement.classList.add(newTheme);
  };

  useEffect(() => {
    if (localStorage.getItem('theme')) {
      setTheme(localStorage.getItem('theme'));
      const htmlElement = document.querySelector('html');
      htmlElement.classList.remove('light', 'dark');
      htmlElement.classList.add(localStorage.getItem('theme'));
    }
  }, []);

  const switchValue = useMemo(() => (theme !== 'dark' ? false : true), [theme]);
  return (
    <div
      className={`${classNameContainer} mx-4 uppercase flex items-center justify-center font-figtree font-bold`}
    >
      <MaterialUISwitch checked={switchValue} onChange={handleToggle} />
    </div>
  );
};

export default ToggleTheme;
